module.exports = __webpack_public_path__ + "static/impact_3_pwdDay-b19273e61f016fd37f5a096227b49f74.png";